import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class LoadingScreenService {
  private loadingSource = new BehaviorSubject<boolean>(true);
  currentLoadingStatus = this.loadingSource.asObservable();

  constructor() { }

  startLoading() {
    this.loadingSource.next(true);
  }

  stopLoading() {
    this.loadingSource.next(false);
  }
}
